<template>
  <main :style="{'--dominant': '#FF0000', '--average': '#FF9C96' }" class="min-h-screen project-gradient p-4 gap-4 px-6 grid grid-cols-1 lg:grid-cols-2" v-if="about">
      <div class="pt-20 lg:pt-20 text-base leading-tight lg:text-2xl space-y-8" v-html="about.contact"></div>
      <div class="pt-20 lg:pt-20 text-base leading-tight lg:text-2xl space-y-8 max-w-3xl justify-self-end" v-html="about.text"></div>
  </main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "about",
  metaInfo() {
    return {
      title: "– About",
      meta: [
        {
          description: this.about.text,
        },
      ],
    };
  },
  computed: mapState(["about"]),
};
</script>
